import React from "react";
import { UnControlled as CodeMirror } from "react-codemirror2";
import CybsButton from '@cybs-ui/components/lib/button';
import {connect} from 'react-redux';
import {getSampleCodeValue, getExampleSummary} from '../../../reducers/examples-reducer';
import 'font-awesome/css/font-awesome.min.css';
import {copyStringToClipboard} from '../../../../../libs/common-library';
import CybsAlert from '@cybs-ui/components/lib/alert';
import {disableCopyMessage} from '../js/live-console';
import {ResizableBox} from 'react-resizable';
import 'react-resizable/css/styles.css';

import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import "codemirror/mode/javascript/javascript.js";

// components
var lines = 0;
var code = "random";
var height = 0;
class SampleCodeViewer extends React.Component {

  state = {
    heightDiv: 373,
  };

  handleKeyDown = (e) => {
    const { heightDiv: height } = this.state;
    switch(e.keyCode) {
      case 38: // up arrow
        this.setState({ heightDiv: height - 10 });
        break;
      case 40: // down arrow
        this.setState({ heightDiv: height + 10 });
        break;
      default:
        break;
    }
  }
  render(){
    // console.log(this.props.exampleValue);
    // const [codeEditorState, setCodeEditorState] = useState();
    // useEffect(() => {
    //   setCodeEditorState(code);
    // }, [code]);
    const { heightDiv } = this.state;
    var copyButtonController;
        copyButtonController = <CybsAlert 
        isInline
        isDismissable
        i18n={{
          message: "Copy Successful"
        }}
        status="positive"
        // isVisible={positiveAlertVisible}
        onDismiss={() =>disableCopyMessage("copySuccessfulSampleCode")}
        />

    const cmOptions = {
      theme: "default",
      background: "#dadde3",
      height: "auto",
      viewportMargin: Infinity,
      mode: {
        name: "javascript",
        json: true,
        statementIndent: 2
      },
      lineNumbers: true,
      lineWrapping: false,
      indentWithTabs: false,
      tabSize: 2
    };
    code = this.props.sampleCodeValue;
    if(this.props.sampleCodeValue != undefined){
      lines = (code.match(/\n/g) || '').length + 5;
    }
    var sampleCodeError = this.props.sampleCodeError;
    if(getExampleSummary() != undefined){
      height = (sampleCodeError != undefined && sampleCodeError != "No Error")?408:457;
    }
    else{
      height = (sampleCodeError != undefined && sampleCodeError != "No Error")?373:421;
    }
    var maxHeight = height;
    if(lines>5){
      maxHeight = lines*20;
    }

    return (
      
      <div className="panel panel-default" style={{width: '100%'}}>
        <CybsAlert 
          isInline 
          status="negative"
          i18n={{
            message: this.props.sampleCodeError
          }}
          isVisible={(this.props.sampleCodeError !== undefined && this.props.sampleCodeError !== 'No Error')}
        />
        <div id = "copySuccessfulSampleCode"style={{display: 'none'}}>{copyButtonController}</div>
        <div style= {{display: 'flex'}} tabIndex="0" onKeyDown={this.handleKeyDown}>
        {/*<img class = "sampleCodeCopyButton" src={copyButton} onClick={() => (copyStringToClipboard(getSampleCodeValue(),enableCopyMessage('copySuccessfulSampleCode')))}></img>*/}
        <ResizableBox width={590} height={heightDiv} minConstraints={[590,height]} maxConstraints={[590,maxHeight]} axis="y" resizeHandles={['se']}>
        <div id="outer-sample-code-editor" style={{height: 'inherit'}}>
        <CodeMirror
          value={this.props.sampleCodeValue}
          options={cmOptions}
          autoCursor={false}
          class= "sampleCodeContainer"
          // onChange={(editor, data, value) => onChange(value)}
        />
        </div>
        </ResizableBox>
        <CybsButton
            colorScheme="secondary"
            className = "sampleCodeCopyButton border_color_theme_primary"
            dataTest="sample-code-copy"
            i18n={{ ariaLabel: <b>information icon</b>, label: 'Copy' }}
            resolution="high"
            iconClass="copy"
            iconLocation="left"
            onClick={() => copyStringToClipboard(getSampleCodeValue(),enableCopyMessage('copySuccessfulSampleCode'))}
            disabled={this.props.sampleCodeValue == undefined || this.props.sampleCodeValue.length <= 0}
        />
        </div>
      </div>
    );
  }
  
};

function enableCopyMessage(id)
{
    var element = document.getElementById(id);
    if(element != null)
    {
        element.style.display = "block";
    }
}

function mapStateToProps(state){
  return{
    sampleCodeValue: state.examplesReducer.sampleCodeValue,
    sampleCodeError: state.examplesReducer.sampleCodeError
  }
}

export default connect(mapStateToProps)(SampleCodeViewer);